export const language: any ={
    LabelLogin: "Masuk",
    LabelForgotPw: "Lupa Kata Sandi",
    LabelSignUp: "Daftar",
    LabelRememberMe: "Ingat Saya",
    Or: "atau",
    Email: "Email",
    Password: "Kata Sandi",
    LangKo: "Korea",
    LangEn: "Inggris",
    LangVi: "Vietnam",
    LabelCondition: "Setuju Syarat & Ketentuan",
    FullAgreement: "Setuju Semua",
    Next: "Lanjut",
    PrivacyPolicy: `Kebijakan Privasi <span class="text-[#ff6741]">(Wajib)</span>`,
    TermOfUse: `Syarat Penggunaan <label class="text-[#ff6741]">(Wajib)</label>`,
    VerifyPassword: "Konfirmasi Kata Sandi",
    PlaceHolderPassword: "Masukkan minimal 8 karakter kombinasi huruf, angka, dan simbol",
    DuplicateCheck: "Cek Duplikasi",
    LabelIdEmail: "ID (Email)",
    GN_02_MSG_01: "Versi aplikasi Anda sudah usang. Silakan perbarui untuk melanjutkan penggunaan.",
    AU_02_MSG_01: "Masukkan format email yang benar.",
    AU_01_MSG_01: "ID atau kata sandi salah. Silakan coba lagi.",
    AU_02_MSG_02: "Email ini sudah terdaftar. Gunakan email lain.",
    AU_02_MSG_03: "Email ini tersedia.",
    AU_02_MSG_04: "Periksa ketersediaan email.",
    AU_02_MSG_05: "Masukkan minimal 8 karakter kombinasi huruf, angka, dan simbol.",
    AU_02_MSG_06: "Kata sandi tidak cocok.",
    AU_03_MSG_01: "Masukkan email dengan benar.",
    AU_03_MSG_02: "Email ini tidak terdaftar dalam sistem.",
    AU_03_MSG_04: "※ Kode verifikasi telah dikirim ke email terdaftar.",
    LabelRegisterComplete: "Pendaftaran berhasil!",
    LabelLoginToUseService: "Silakan masuk untuk menggunakan layanan.",
    LabelDontRememberPassword: "Lupa kata sandi?",
    LabelYouCanFindEmail: "Dapat ditemukan melalui verifikasi email.",
    LabelPasswordTemporarySendToEmail: "※ Kata sandi sementara akan dikirim ke email terdaftar.",
    SendVerifyNumber: "Kirim Kode Verifikasi",
    LabelCheckYourEmailForTemporaryPassword: "Periksa email untuk kata sandi sementara.",
    PlaceHolderTemporaryPassword: "Masukkan kata sandi sementara",
    LabelTemporaryPassword: "Kata Sandi Sementara",
    LabelDidntReceiveYourPassword: "Belum menerima kata sandi?",
    LabelYouCanResendItAfter: "dapat dikirim ulang setelah",
    LabelYouCanResendAgain: "Dapat dikirim ulang.",
    Confirm: "Konfirmasi",
    Resend: "Kirim Ulang",
    LabelResetPassword: "Atur Ulang Kata Sandi",
    NewPassword: "Kata Sandi Baru",
    ConfirmNewPassword: "Konfirmasi Kata Sandi Baru",
    PlaceHolderConfirmPassword: "Konfirmasi Kata Sandi",
    CurrentPassword: "Kata Sandi Saat Ini",
    LanguageSetting: "Pengaturan Bahasa",
    LeaveMembership: "Hapus Akun",
    LabelConfirmPasswordToLeaveMemberShip: "Konfirmasikan kata sandi untuk menghapus akun.",
    LabelConfirmPasswordMeansYouAgreeAllContent: "Konfirmasi kata sandi berarti Anda menyetujui semua isi panduan.",
    LabelCancelMembership: "Hapus Akun",
    LabelBeforeLeaveYouCheckedContent: "Baca dan centang untuk setuju sebelum menghapus akun.",
    LabelAfterLeaveAllInfoWillRemove: "Setelah penghapusan, semua informasi akun akan dihapus secara permanen.",
    LabelIHaveReadAndAgreeContent: "Saya telah membaca dan menyetujui semua panduan.",
    ToUnsubscribe: "Batalkan Langganan",
    LabelWouldYouWantLogout: "Ingin keluar?",
    ChangePassword: "Ganti Kata Sandi",
    Menu: "Menu",
    MenuLanguageSettings: "Pengaturan Bahasa",
    MenuPrivacyPolicy: "Kebijakan Privasi",
    MenuLogout: "Keluar",
    MenuLeaveMembership: "Hapus Akun",
    LabelAreYouSureLeaveMembership: "Apakah Anda yakin ingin menghapus akun?",
    LabelIfLeaveMembershipAllInfoWillRemove: "Jika dihapus, semua informasi akun akan dihapus secara permanen.",
    LabelPrivacyPolicy: "Kebijakan Privasi",
    LabelTermOfUse: "Syarat Penggunaan",
    MI_02_MSG_01: "Kata sandi saat ini tidak benar.",
    LabelModalLogin: `Untuk menggunakan fitur ini,<br/>silakan masuk atau mendaftar.`,
    LabelIdLogin: "Login dengan ID",
    LabelSnsApple: "Login dengan Apple",
    LabelSnsFacebook: "Login dengan Facebook",
    LabelSnsGoogle: "Login dengan Google",
    LabelItemLogin: "Hey! Untuk menjelajahi berbagai fitur bersama Cooker, silakan login atau daftar.",
    LabelSnsEmail: "Login dengan Email",
    LoadingLogin: "Mohon tunggu sebentar.",
    MenuNotificationSettings: "Pengaturan Notifikasi", //menu
};
